import { FC } from 'react'

import { CountryCode } from 'libphonenumber-js'

import NoFlag from 'src/Assets/Png/NoFlag.png'

export type CountryFlagProps = {
  country?: CountryCode
  width?: number
  height?: number
}

export const CountryFlag: FC<CountryFlagProps> = ({
  country = 'US',
  width,
  height,
}) => {
  if (!country) {
    return null
  }

  return (
    <img
      src={`https://flagcdn.com/${country.toLowerCase()}.svg`}
      alt={`${country} flag`}
      width={width}
      height={height}
      loading='lazy'
      onError={(e) => {
        e.currentTarget.src = NoFlag
      }}
    />
  )
}
